// extracted by mini-css-extract-plugin
export default {"board":"Board_board__elPzM","feedback":"Board_feedback__HZUtY","validity":"Board_validity__abSQo","help":"Board_help__ZcLbC","italic":"Board_italic__e9e--"};